import { useEffect } from 'react';
import type { IMe } from '@platform/core/types';
import { meApi, useWorkspaceQuery } from '@platform/state/api';
import { useAppDispatch } from '@platform/state/hooks';
import type { IVisitedWorkspace } from './IVisitedWorkspace';
import type { VisitState } from './VisitState';

/**
 * Поточний простір вкладки (ADR-028), де користувач не учасник (прототип v4 показує будь-який простір, на який указує стан): якщо сервер дає його читати
 * (GET /workspaces/{id} — адміністратор платформи, демо-простори), простір відкривається, а його запис (назва, тип, можливості) додається до
 * кешу «я» з позначкою `visiting`, тож усі сторінки знаходять його як поточний; перемикач його не перелічує. Відмова сервера — 'denied'.
 */
export function useVisitedWorkspace(ws: string, me: IMe | undefined): VisitState {
  const dispatch = useAppDispatch();
  const member = !!me?.workspaces.some((w) => w.id === ws && !(w as IVisitedWorkspace).visiting);
  const listed = !!me?.workspaces.some((w) => w.id === ws);
  const { data, isLoading, isFetching } = useWorkspaceQuery(ws, { skip: !ws || !me || member });
  useEffect(() => {
    if (!data || listed || member) return;
    dispatch(meApi.util.updateQueryData('me', undefined, (draft) => {
      if (!draft.workspaces.some((w) => w.id === data.id)) draft.workspaces.push({ ...data, visiting: true } as IVisitedWorkspace);
    }));
  }, [data, listed, member, dispatch]);
  if (member) return 'member';
  if (data && data.id === ws) return 'visiting';
  return isLoading || isFetching ? 'loading' : 'denied';
}
